export const formatAddress = (addr: string): string =>
  addr.substring(0, 5) + "..." + addr.substring(addr.length - 5, addr.length);
